import { ChatCenteredIcon, CheckCircleIcon, Clock, Eye } from "@phosphor-icons/react";
import {
  APP_COLORS,
  ENUM_INTRESTED_IN_PRIORITY_LIST,
  ENUM_LOOKING_FOR,
  ENUM_PROJECT_ARCHIVE_REASON,
  ENUM_PROJECT_STATUS,
  ENUM_PROJECT_STATUS_CATEGORY,
  ENUM_QUALIFY_QUESTION_TYPES,
  ENUM_RESCHEDULE_REASON_TYPE,
  ENUM_USER_ROLE,
} from "../enums";

type ProjectStatusListItem = {
  label: string | Partial<Record<ENUM_USER_ROLE, string>>;
  bgColor?: string;
  eventbgColor?: string;
  projectStatusBgColor?: string;
  projectStatusTextColor?: string;
  category?: ENUM_PROJECT_STATUS_CATEGORY;
  isClosedStatus?: boolean;
  step?: number;
};

type MeetingsTabStatusFilterRow = {
  status: ENUM_PROJECT_STATUS;
  label?: string;
};

const IMAGES_PATH = process.env.PUBLIC_URL + "/assets/imgs";

export const ALL_USER_ROLES = [ENUM_USER_ROLE.ADMIN,
ENUM_USER_ROLE.AMBASSADOR,
ENUM_USER_ROLE.VENDOR,
ENUM_USER_ROLE.DELEGATE_VENDOR];

export const CONST_TYPEFORM_TYPES = [
  { label: "Short Text", value: ENUM_QUALIFY_QUESTION_TYPES.SHORT_TEXT },
  { label: "Yes/No", value: ENUM_QUALIFY_QUESTION_TYPES.BOOLEAN },
  { label: "Multiple Select", value: ENUM_QUALIFY_QUESTION_TYPES.MULTI_SELECT },
];

export const CONST_LOOKING_FOR_LIST = [
  {
    label: "1:1 Introductory Sales Meetings",
    value: ENUM_LOOKING_FOR.ONE2ONE_INTRODUCTORY_SALES_MEETINGS,
  },
  { label: "1:1 Advisory Meetings", value: ENUM_LOOKING_FOR.ONE2ONE_ADVISORY },
  {
    label: "Advisory Board Members",
    value: ENUM_LOOKING_FOR.ADVISORY_BOARD_MEMBERS,
  },
  { label: "Investors", value: ENUM_LOOKING_FOR.INVESTORS },
];

export const CONST_INTRESTED_IN_PRIORITY_LIST = [
  {
    label: "Low",
    value: ENUM_INTRESTED_IN_PRIORITY_LIST.LOW,
  },
  { label: "Medium", value: ENUM_INTRESTED_IN_PRIORITY_LIST.MEDIUM },
  {
    label: "High",
    value: ENUM_INTRESTED_IN_PRIORITY_LIST.HIGH,
  },
];

export const CONST_PROJECT_STATUS_LIST: Record<
  ENUM_PROJECT_STATUS,
  ProjectStatusListItem
> = {
  [ENUM_PROJECT_STATUS.CREATED]: {
    label: "Created",
    bgColor: APP_COLORS.primaryLight,
    eventbgColor: APP_COLORS.primary,
    projectStatusBgColor: APP_COLORS.primaryLight,
    projectStatusTextColor: APP_COLORS.primary,
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 1,
  },
  [ENUM_PROJECT_STATUS.REQUESTED]: {
    label: {
      [ENUM_USER_ROLE.VENDOR]: "Awaiting Responses",
      [ENUM_USER_ROLE.DELEGATE_VENDOR]: "Awaiting Responses",
      [ENUM_USER_ROLE.AMBASSADOR]: "New Request",
    },
    bgColor: APP_COLORS.primaryLight,
    eventbgColor: APP_COLORS.primary,
    projectStatusBgColor: APP_COLORS.primaryLight,
    projectStatusTextColor: APP_COLORS.primary,
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 1,
  },

  [ENUM_PROJECT_STATUS.DONE]: {
    label: "Completed",
    bgColor: APP_COLORS.successLight,
    eventbgColor: APP_COLORS.successLight,
    projectStatusBgColor: APP_COLORS.successLight,
    projectStatusTextColor: APP_COLORS.successDark3,
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    step: 6,
  },
  [ENUM_PROJECT_STATUS.DONE_BY_CLIENT]: {
    label: "Mark as done by client",
    bgColor: APP_COLORS.markAsDoneBgColor,
    eventbgColor: APP_COLORS.markAsDoneBgColor,
    projectStatusBgColor: APP_COLORS.markAsDoneBgColor,
    projectStatusTextColor: APP_COLORS.markAsDoneTextColor,
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
  },
  [ENUM_PROJECT_STATUS.DONE_BY_AMBASSADOR]: {
    label: "Mark as done by ambassador",
    bgColor: APP_COLORS.markAsDoneBgColor,
    eventbgColor: APP_COLORS.markAsDoneBgColor,
    projectStatusBgColor: APP_COLORS.markAsDoneBgColor,
    projectStatusTextColor: APP_COLORS.markAsDoneTextColor,
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
  },

  [ENUM_PROJECT_STATUS.REJECTED]: {
    label: "Rejected",
    bgColor: APP_COLORS.errorLight,
    eventbgColor: APP_COLORS.error,
    projectStatusBgColor: APP_COLORS.errorLight,
    projectStatusTextColor: APP_COLORS.errorDark,
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
  },
  [ENUM_PROJECT_STATUS.REJECTED_BY_CLIENT]: {
    label: "Rejected By Vendor",
    bgColor: APP_COLORS.errorLight,
    eventbgColor: APP_COLORS.error,
    projectStatusBgColor: APP_COLORS.errorLight,
    projectStatusTextColor: APP_COLORS.errorDark,
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
  },
  [ENUM_PROJECT_STATUS.REJECTED_BY_AMBASSADOR]: {
    label: "Rejected By Ambassador",
    bgColor: APP_COLORS.errorLight,
    eventbgColor: APP_COLORS.error,
    projectStatusBgColor: APP_COLORS.errorLight,
    projectStatusTextColor: APP_COLORS.errorDark,
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
  },
  [ENUM_PROJECT_STATUS.CANCELED_BY_CLIENT]: {
    label: "Canceled by Vendor",
    bgColor: APP_COLORS.errorLight,
    eventbgColor: APP_COLORS.error,
    projectStatusBgColor: APP_COLORS.errorLight,
    projectStatusTextColor: APP_COLORS.errorDark,
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
  },
  [ENUM_PROJECT_STATUS.CANCELED_BY_AMBASSADOR]: {
    label: "Canceled by Ambassador",
    bgColor: APP_COLORS.errorLight,
    eventbgColor: APP_COLORS.error,
    projectStatusBgColor: APP_COLORS.errorLight,
    projectStatusTextColor: APP_COLORS.errorDark,
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
  },
  [ENUM_PROJECT_STATUS.ARCHIVE]: {
    label: "Archived",
    bgColor: APP_COLORS.errorLight,
    eventbgColor: APP_COLORS.error,
    projectStatusBgColor: APP_COLORS.errorLight,
    projectStatusTextColor: APP_COLORS.errorDark,
    category: ENUM_PROJECT_STATUS_CATEGORY.PAST,
    isClosedStatus: true,
    step: 6,
  },
  [ENUM_PROJECT_STATUS.AWAITING_FOR_RESPONSE]: {
    label: "Awaiting for response",
    bgColor: APP_COLORS.infoLight,
    eventbgColor: APP_COLORS.info,
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 1,
  },

  [ENUM_PROJECT_STATUS.RESPONDED]: {
    label: "Responded",
    bgColor: APP_COLORS.infoLight,
    eventbgColor: APP_COLORS.info,
    projectStatusTextColor: APP_COLORS.infoDark3,
    projectStatusBgColor: APP_COLORS.infoLight,
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 2,
  },
  [ENUM_PROJECT_STATUS.ADDED_TIME_SLOTS_BY_CLIENT]: {
    label: "Vendor Proposed Times",
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    projectStatusTextColor: APP_COLORS.yellowDark3,
    projectStatusBgColor: APP_COLORS.yellowLight,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 3,
  },
  [ENUM_PROJECT_STATUS.SUGGESTED_TIME_SLOT_BY_AMBASSADOR]: {
    label: "Times Suggested",
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    projectStatusTextColor: APP_COLORS.yellowDark3,
    projectStatusBgColor: APP_COLORS.yellowLight,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 3,
  },
  [ENUM_PROJECT_STATUS.APPROVED_BY_CLIENT]: {
    label: {
      [ENUM_USER_ROLE.VENDOR]: "Approved",
      [ENUM_USER_ROLE.DELEGATE_VENDOR]: "Approved",
      [ENUM_USER_ROLE.OPPORTUNITY_VENDOR]: "Approved",
      [ENUM_USER_ROLE.AMBASSADOR]: "Waiting on Client",
    },
    bgColor: APP_COLORS.successLight,
    eventbgColor: APP_COLORS.success,
    projectStatusBgColor: APP_COLORS.successLight,
    projectStatusTextColor: APP_COLORS.success,
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 3,
  },
  [ENUM_PROJECT_STATUS.AWAITING_FOR_TIME_SLOT]: {
    label: "Awaiting for times",
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    category: ENUM_PROJECT_STATUS_CATEGORY.NEW,
    step: 3,
  },
  [ENUM_PROJECT_STATUS.SELECTED_TIME_SLOT_BY_AMBASSADOR]: {
    label: {
      [ENUM_USER_ROLE.VENDOR]: "Selected times by ambassador",
      [ENUM_USER_ROLE.DELEGATE_VENDOR]: "Selected times by ambassador",
      [ENUM_USER_ROLE.OPPORTUNITY_VENDOR]: "Selected times by ambassador",
      [ENUM_USER_ROLE.AMBASSADOR]: "Times Submitted",
    },
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    projectStatusTextColor: APP_COLORS.yellowDark3,
    projectStatusBgColor: APP_COLORS.yellowLight,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
  },
  [ENUM_PROJECT_STATUS.UNAVAILABLE_TIME_SLOT_BY_CLIENT]: {
    label: "Requested coordination by client",
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    projectStatusBgColor: APP_COLORS.yellowLight,
    projectStatusTextColor: APP_COLORS.yellowDark3,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
  },
  [ENUM_PROJECT_STATUS.UNAVAILABLE_TIME_SLOT_BY_AMBASSADOR]: {
    label: "Requested coordination by ambassador",
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    projectStatusBgColor: APP_COLORS.yellowLight,
    projectStatusTextColor: APP_COLORS.yellowDark3,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
  },
  [ENUM_PROJECT_STATUS.AWAITING_FOR_TIME_SLOT_SELECTION]: {
    label: "Awaiting for times selection",
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
  },

  [ENUM_PROJECT_STATUS.SEND_MEETING_LINK]: {
    label: "Scheduled",
    bgColor: APP_COLORS.secondaryLight,
    eventbgColor: APP_COLORS.secondary,
    projectStatusBgColor: APP_COLORS.secondaryLight,
    projectStatusTextColor: APP_COLORS.secondaryDark,
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
  },
  [ENUM_PROJECT_STATUS.UPDATE_INVITATION]: {
    label: "Invititation Updated",
    bgColor: APP_COLORS.secondary,
    eventbgColor: APP_COLORS.secondary,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
  },
  [ENUM_PROJECT_STATUS.CONFIRMED_ATTENDANCE_BY_AMBASSADOR]: {
    label: "Attendance Confirmed",
    bgColor: APP_COLORS.secondaryLight,
    eventbgColor: APP_COLORS.secondary,
    projectStatusBgColor: APP_COLORS.secondaryLight,
    projectStatusTextColor: APP_COLORS.secondaryDark,
    category: ENUM_PROJECT_STATUS_CATEGORY.UPCOMING,
    step: 5,
  },
  [ENUM_PROJECT_STATUS.VENDOR_RESCHEDULE_REQUESTED]: {
    label: "Reschedule Requested",
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    projectStatusBgColor: APP_COLORS.yellowLight,
    projectStatusTextColor: APP_COLORS.yellowDark3,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
  },
  [ENUM_PROJECT_STATUS.AMBASSADOR_RESCHEDULE_REQUESTED]: {
    label: "Reschedule Requested",
    bgColor: APP_COLORS.yellowLight,
    eventbgColor: APP_COLORS.yellow,
    projectStatusBgColor: APP_COLORS.yellowLight,
    projectStatusTextColor: APP_COLORS.yellowDark3,
    category: ENUM_PROJECT_STATUS_CATEGORY.SCHEDULING,
    step: 4,
  },
};

export const CONST_DELEGATE_SCHEDULING_NO_STEP_STATUSES = [
  ENUM_PROJECT_STATUS.UNAVAILABLE_TIME_SLOT_BY_CLIENT,
  ENUM_PROJECT_STATUS.UNAVAILABLE_TIME_SLOT_BY_AMBASSADOR,
  ENUM_PROJECT_STATUS.UPDATE_INVITATION,
];

export const CONST_PROJECT_ARCHIVE_REASON = {
  [ENUM_PROJECT_ARCHIVE_REASON.CANCELLED]: "Canceled",
  [ENUM_PROJECT_ARCHIVE_REASON.RE_SCHEDULE]: "Re-schedule",
};

export const PROJECT_DETAILS_CARD_ACTION_LABELS = {
  [ENUM_PROJECT_STATUS.REQUESTED]: {
    [ENUM_USER_ROLE.VENDOR]: {
      label: "",
      action: "view",
      icon: <Eye />,
    },
    [ENUM_USER_ROLE.AMBASSADOR]: {
      label: "Answer Questions",
      action: "answer_questions",
      icon: <ChatCenteredIcon />,
    },
  },
  [ENUM_PROJECT_STATUS.RESPONDED]: {
    [ENUM_USER_ROLE.VENDOR]: {
      label: "Proceed / Decline",
      action: "approve_or_reject_request",
      icon: <CheckCircleIcon />,
    },
    [ENUM_USER_ROLE.AMBASSADOR]: {
      label: "",
      action: "view",
      icon: <Eye />,
    },
  },
  [ENUM_PROJECT_STATUS.APPROVED_BY_CLIENT]: {
    [ENUM_USER_ROLE.VENDOR]: {
      label: "Suggest Times",
      action: "select_available_time",
      icon: <Clock />,
    },
    [ENUM_USER_ROLE.AMBASSADOR]: {
      label: "",
      action: "view",
      icon: <Eye />,
    },
  },
  [ENUM_PROJECT_STATUS.ADDED_TIME_SLOTS_BY_CLIENT]: {
    [ENUM_USER_ROLE.VENDOR]: {
      label: "",
      action: "view",
      icon: <Eye />,
    },
    [ENUM_USER_ROLE.AMBASSADOR]: {
      label: "Share Availability",
      action: "provide_your_availability",
      icon: <Clock />,
    },
  },
  [ENUM_PROJECT_STATUS.SUGGESTED_TIME_SLOT_BY_AMBASSADOR]: {
    [ENUM_USER_ROLE.VENDOR]: {
      label: "Confirm Time",
      action: "",
      icon: <Clock />,
    },
    [ENUM_USER_ROLE.AMBASSADOR]: {
      label: "",
      action: "view",
      icon: <Eye />,
    },
  },
  [ENUM_PROJECT_STATUS.VENDOR_RESCHEDULE_REQUESTED]: {
    [ENUM_USER_ROLE.VENDOR]: {
      label: "",
      action: "select_available_time",
      icon: <Clock />,
    },
    [ENUM_USER_ROLE.DELEGATE_VENDOR]: {
      label: "",
      action: "select_available_time",
      icon: <Clock />,
    },
    [ENUM_USER_ROLE.AMBASSADOR]: {
      label: "",
      action: "view",
      icon: <Eye />,
    },
  },
  [ENUM_PROJECT_STATUS.AMBASSADOR_RESCHEDULE_REQUESTED]: {
    [ENUM_USER_ROLE.VENDOR]: {
      label: "",
      action: "view",
      icon: <Eye />,
    },
    [ENUM_USER_ROLE.DELEGATE_VENDOR]: {
      label: "",
      action: "view",
      icon: <Eye />,
    },
    [ENUM_USER_ROLE.AMBASSADOR]: {
      label: "",
      action: "provide_your_availability",
      icon: <Clock />,
    },
  },
};

export const PAGE_SIZES = [10, 20, 50, 100];

export const CONST_MP_CERTIFICATION_LIST = ["ISO", "FedRamp", "SOC2"];

export const FILE_TYPE_ICONS = {
  pdf: `${IMAGES_PATH}/pdf_icon.svg`,
  doc: `${IMAGES_PATH}/doc_icon.svg`,
  docx: `${IMAGES_PATH}/doc_icon.svg`,
  demo: `${IMAGES_PATH}/play_icon.svg`,
  default: `${IMAGES_PATH}/file-upload-icon.png`,
};

export const CONST_SERVER_ERROR_CODES = {
  LICENSE_ERROR:
    "Your meeting license limit has been reached. Please contact support to renew or upgrade your license",
  NOT_ALLOW_TO_UPDATE_QUESTIONS: "You are not allowed to update questions",
  TIME_SLOT_CONFLICT: "Time slot conflict",
};

export const MEETINGS_TAB_STATUS_FILTERS_BASE: MeetingsTabStatusFilterRow[] = [
  { status: ENUM_PROJECT_STATUS.AWAITING_FOR_RESPONSE },
  { status: ENUM_PROJECT_STATUS.RESPONDED },
  { status: ENUM_PROJECT_STATUS.APPROVED_BY_CLIENT },
  { status: ENUM_PROJECT_STATUS.SUGGESTED_TIME_SLOT_BY_AMBASSADOR },
  { status: ENUM_PROJECT_STATUS.SEND_MEETING_LINK },
  { status: ENUM_PROJECT_STATUS.DONE },
];

export const MEETING_RESCHEDULE_REASONS = [
  {
    label: "Scheduling conflict",
    value: ENUM_RESCHEDULE_REASON_TYPE.SCHEDULING_CONFLICT,
  },
  {
    label: "Emergency",
    value: ENUM_RESCHEDULE_REASON_TYPE.EMERGENCY,
  },
  {
    label: "Availability changed",
    value: ENUM_RESCHEDULE_REASON_TYPE.AVAILABILITY_CHANGED,
  },
  {
    label: "Technical issue",
    value: ENUM_RESCHEDULE_REASON_TYPE.TECHNICAL_ISSUE,
  },
  {
    label: "Other",
    value: ENUM_RESCHEDULE_REASON_TYPE.OTHER,
  },
] as const;

export type MeetingRescheduleReason =
  (typeof MEETING_RESCHEDULE_REASONS)[number]["value"];

